module.exports = __webpack_public_path__ + "img/SL.98fe90e6.svg";